<template>
  <div class="kd-sidebar-icons">
    <ul class="kd-sidebar-icons__list">
      <kd-theme-color-switcher label="Grundfarbe"></kd-theme-color-switcher>
      <kd-sidebar-icon
        label="Vorschau"
        :icon="icons.preview"
        action="SHOW_PREVIEW"
        tooltip-text=""
      ></kd-sidebar-icon>
      <kd-sidebar-icon
        label="Layout"
        :icon="icons.layout"
        action="ACTIVATE_LAYOUT_MODE"
        :tooltip-text="tipsTooltipText"
      ></kd-sidebar-icon>
      <kd-sidebar-icon
        label="Tipps"
        :icon="icons.tips"
        action="TOGGLE_TOOLTIPS"
        tooltip-text=""
      ></kd-sidebar-icon>
    </ul>
  </div>
</template>

<script>
import KdSidebarIcon from '@/components/KdSidebarIcon.vue';
import KdThemeColorSwitcher from '@/components/KdThemeColorSwitcher.vue';

import tooltipTexts from '@/store/tooltip-texts';

export default {
  data() {
    return {
      /* eslint-disable global-require */
      /* is there a better way to pass the images as props? */
      icons: {
        color: require('../assets/images/icons/view.svg'),
        preview: require('../assets/images/icons/view.svg'),
        layout: require('../assets/images/icons/layout.svg'),
        tips: require('../assets/images/icons/light-bulb.svg'),
      },
    };
  },
  computed: {
    tipsTooltipText: () => tooltipTexts.tips,
  },
  components: {
    KdSidebarIcon,
    KdThemeColorSwitcher,
  },
};
</script>

<style lang="scss">
.kd-sidebar-icons {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.kd-sidebar-icons__list {
  padding-right: 12px;
  padding-bottom: 10vh; // make sure the elemenet does not clash with the checkout buttons

  @media all and (max-width: 1200px) {
    padding-right: 6px;
  }
}
</style>
